module.exports = __webpack_public_path__ + "static/media/walk.d1510120.gif";